import merge from 'lodash/merge'

import {
	FETCH_TRANSACTION_TOKEN_BEGIN,
	FETCH_TRANSACTION_TOKEN_SUCCESS,
	FETCH_TRANSACTION_TOKEN_FAILURE,
	FETCH_PSP_SESSION_ID_LOADING,
	SET_PSP_SESSION_ID
} from '../actions/fetchTransactionToken'

const initialState = {
	loading: false,
	error: null,
	pspSessionIdLoading: false,
	pspSessionId: null
}

export default function fetchTransactionTokenData(state = initialState, action) {
	switch(action.type) {
		case FETCH_TRANSACTION_TOKEN_BEGIN:
			return {
				...state,
				loading: true,
				error: null
			}

		case FETCH_TRANSACTION_TOKEN_SUCCESS:
			return {
				...state,
				loading: false,
				tokens: merge({}, state.tokens, action.payload)
			}

		case FETCH_TRANSACTION_TOKEN_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload.error,
				tokens: [],
				pspSessionId: null
			}

		case FETCH_PSP_SESSION_ID_LOADING:
			return {
				...state,
				pspSessionIdLoading: action.payload,
			}

		case SET_PSP_SESSION_ID:
			return {
				...state,
				pspSessionIdLoading: false,
				pspSessionId: action.payload,
			}

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/fetchTransactionTokenReducers.js